"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.classifyPerformanceZone = classifyPerformanceZone;
exports.classifyTrend = classifyTrend;
const ZONE_LABELS = {
    below: "Ispod očekivanja",
    neutral: "U okviru očekivanog",
    above: "Iznad norme",
};
/**
 * Classifies a performance ratio (as a percentage, e.g. 106.58 for 106,58%)
 * into a semantic zone using company-configurable thresholds. Never hides or
 * alters the underlying ratio value — classification is display metadata only.
 */
function classifyPerformanceZone(performanceRatioPercent, thresholds) {
    if (performanceRatioPercent < thresholds.lowerNeutralThreshold) {
        return { zone: "below", label: ZONE_LABELS.below };
    }
    if (performanceRatioPercent > thresholds.aboveNormThreshold) {
        return { zone: "above", label: ZONE_LABELS.above };
    }
    return { zone: "neutral", label: ZONE_LABELS.neutral };
}
function classifyTrend(deltaPercentagePoints) {
    const direction = deltaPercentagePoints > 0 ? "up" : deltaPercentagePoints < 0 ? "down" : "flat";
    return { direction, deltaPercentagePoints };
}
//# sourceMappingURL=performance-zone.js.map